import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_BACKEND + "residents/" : process.env.REACT_APP_DEV_BACKEND + "residents/";

export const residentApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: API_URL,
        prepareHeaders: (headers) => {
            const user = JSON.parse(localStorage.getItem("user"));
            if (user && user.accessToken) {
                headers.set("authorization", user.accessToken);
            }
            return headers;
        },
    }),
    reducerPath: "residentApi",
    tagTypes: ["Summary", "Residents", "Logs"],
    endpoints: (build) => ({
        getSummary: build.query({
            query: (month) => ({
                url: "summary",
                params: month ? { month } : {},
            }),
            providesTags: ["Summary"],
        }),
        getResidents: build.query({
            query: () => "",
            providesTags: ["Residents"],
        }),
        addResident: build.mutation({
            query: ({ name, specialty }) => ({
                url: "",
                method: "POST",
                body: { name, specialty },
            }),
            invalidatesTags: ["Residents", "Summary"],
        }),
        updateResident: build.mutation({
            query: ({ id, name, specialty }) => ({
                url: id,
                method: "PUT",
                body: { name, specialty },
            }),
            invalidatesTags: ["Residents", "Summary", "Logs"],
        }),
        deleteResident: build.mutation({
            query: (id) => ({
                url: id,
                method: "DELETE",
            }),
            invalidatesTags: ["Residents", "Summary", "Logs"],
        }),
        getLogs: build.query({
            query: (resident) => ({
                url: "logs",
                params: resident ? { resident } : {},
            }),
            providesTags: ["Logs"],
        }),
        addLog: build.mutation({
            query: ({ resident, kind, category, date, notes }) => ({
                url: "logs",
                method: "POST",
                body: { resident, kind, category, date, notes },
            }),
            invalidatesTags: ["Logs", "Summary"],
        }),
        deleteLog: build.mutation({
            query: (id) => ({
                url: `logs/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Logs", "Summary"],
        }),
    })
})

export const {
    useGetSummaryQuery,
    useGetResidentsQuery,
    useAddResidentMutation,
    useUpdateResidentMutation,
    useDeleteResidentMutation,
    useGetLogsQuery,
    useAddLogMutation,
    useDeleteLogMutation,
} = residentApi;
